// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"411198c0c6a881ce47e6","873":"0fe7b5a83744c073f677"}[chunkId] + ".js";
};